import React, { useState, useRef, useEffect } from 'react';
import { MdFileDownload, MdKeyboardArrowDown } from 'react-icons/md';
import './ExportDropdown.css';

interface ExportDropdownProps {
  onExportPDF: () => void;
  onExportExcel: () => void;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({ onExportPDF, onExportExcel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const DownloadIcon = MdFileDownload as React.ComponentType<{ className?: string }>;
  const ChevronIcon = MdKeyboardArrowDown as React.ComponentType<{ className?: string }>;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleOptionClick = (callback: () => void) => {
    callback();
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="export-dropdown-wrapper">
      <button
        className={`export-dropdown-button ${isOpen ? 'export-dropdown-button-open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <DownloadIcon className="export-dropdown-icon" />
        <span>Export</span>
        <ChevronIcon className={`export-dropdown-chevron ${isOpen ? 'export-dropdown-chevron-open' : ''}`} />
      </button>
      {isOpen && (
        <div className="export-dropdown-menu">
          <div
            className="export-dropdown-option"
            onClick={() => handleOptionClick(onExportPDF)}
          >
            PDF
          </div>
          <div
            className="export-dropdown-option"
            onClick={() => handleOptionClick(onExportExcel)}
          >
            Excel
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
